<script>
    import { auth } from '../firebase';
</script>

<style>
    /* TODO: Move these into a button component? */
    button {
        background-color: #d8d8d8;
        color: black;
        border-radius: 3px;
        padding: 7px 14px 7px 16px;
        border: none;
        font-family: Whitney, Helvetica Neue, Helvetica, Arial, sans-serif;
        transition: 0.3s;
        width: auto;
        white-space: nowrap;
        /* width: 100%; */
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    button:hover {
        background-color: #929292;
    }
</style>

<button on:click={() => {
    auth.signOut().then(() => {
        // Sign-out successful.
    }).catch(e => {
        console.error(`Error signing out: ${e}`);
    });
}}>Sign out</button>